import React, { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const StaffAuthContext = createContext(null);

export function StaffAuthProvider({ children }) {
  const [staff, setStaff] = useState(null);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const { data } = await api.get("/staff/me");
        if (!cancelled) setStaff(data);
      } catch (_e) { /* not logged in */ }
      finally { if (!cancelled) setReady(true); }
    })();
    return () => { cancelled = true; };
  }, []);

  async function login(identifier, password) {
    const { data } = await api.post("/staff/auth/login", { identifier, password });
    setStaff(data);
    return data;
  }

  async function logout() {
    try { await api.post("/staff/auth/logout"); }
    catch (_e) { /* ignore */ }
    setStaff(null);
  }

  async function refresh() {
    try {
      const { data } = await api.get("/staff/me");
      setStaff(data);
      return data;
    } catch (_e) {
      setStaff(null);
      return null;
    }
  }

  return (
    <StaffAuthContext.Provider value={{ staff, ready, login, logout, refresh }}>
      {children}
    </StaffAuthContext.Provider>
  );
}

export function useStaffAuth() {
  const ctx = useContext(StaffAuthContext);
  if (!ctx) throw new Error("useStaffAuth must be used within StaffAuthProvider");
  return ctx;
}
